import feedPostsApi from "@/api/posts/client";
import { FeedPostDto } from "@/api/posts/types";
import { useMutation } from "@tanstack/react-query";
import usePostInvalidation from "./usePostInvalidation";

export default function usePostDelete(
  feedPost: FeedPostDto,
  onClose: () => void,
) {
  const invalidatePosts = usePostInvalidation();

  const { mutateAsync: deletePost, isLoading } = useMutation({
    mutationFn: () => feedPostsApi.deleteFeedPost(feedPost.id!),
    onSuccess: () => {
      invalidatePosts();
      onClose();
    },
  });

  return { deletePost, isLoading };
}
